import { Button } from '@idexx-laboratories/spot-react';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';
import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router';
import Grid from '../../components/Grid/Grid';
import Loader from '../../components/Loader/Loader';
import SearchBarExtended from '../../components/SearchBarExtended/SearchBarExtended';
import { useBackBlocker } from '../../hooks/use-back-blocker';
import { useStore } from '../../hooks/use-store';
import './ManageBreeds.scss';
import { SubRowRenderer } from './renderers';

const ManageBreeds = observer(() => {
  const navigate = useNavigate();
  const { manageBreedsStore: store, globalModalStore } = useStore();
  const { colDefs, expandedRowIds, mappedSpeciesBreeds, loaders, hasUnsavedChanges, searchText } =
    store;

  useEffect(() => {
    store.init();
    return () => store.close();
  }, [store]);

  useBackBlocker(
    useCallback(
      allowBack => {
        if (hasUnsavedChanges) {
          globalModalStore.showLeavePagePopup(() => allowBack());
        } else {
          allowBack();
        }
      },
      [globalModalStore, hasUnsavedChanges],
    ),
  );

  return (
    <div className='manage-breeds_wrapper'>
      <div className='spot-typography__heading--level-2'>Manage Breeds</div>
      <div className='spot-typography__text--tertiary'>
        Match additional Cornerstone canine and feline breeds to Trupanion&apos;s breeds list.
        <br />
        This information helps to accurately assess offers eligibility of your clients.
      </div>
      <SearchBarExtended
        aria-label='breed-search'
        value={searchText}
        placeholder='Search for Cornerstone Canine and Feline Breeds'
        onSearchClick={v => runInAction(() => (store.searchText = v))}
        data-testid='search-agents'
      />
      <Grid
        id='breeds-management-grid'
        columns={colDefs}
        data={mappedSpeciesBreeds}
        expandedRowIds={expandedRowIds}
        rowIdField='id'
        subrowRenderer={SubRowRenderer}
      />
      <div className='page-bottom-actions'>
        <Button
          variant='link'
          size='small'
          className='back'
          onClick={() => void navigate(-1)}
          data-testid='back-btn'
        >
          Back
        </Button>
        <div>
          <Button
            variant='secondary'
            size='small'
            data-testid='dashboard-btn'
            onClick={() => void navigate('/')}
          >
            Dashboard
          </Button>
          <Button
            variant='primary'
            size='small'
            data-testid='update-cornerstone-btn'
            onClick={() => void store.saveBreedsMapping()}
          >
            <Loader loading={loaders.save}>Update Cornerstone</Loader>
          </Button>
        </div>
      </div>
    </div>
  );
});

export default ManageBreeds;
